$(() => {
	$('.block-page-header.has-ken-burns-animation').addClass('animate');
	$('.block-page-header.has-fade-in-animation').addClass('animate');
})
